var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"120"}}),_c('h4',{staticClass:"mt-5"},[_vm._v("EV Drive")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }